import React from 'react';
import { Icon, Text, Spinner } from '../../../common/components';
import { IconNames } from '../../../common/components/Icon/IconNames';
import { t } from '../../../common/i18n';
import BuildingLog, { BuildingLogItem } from '../buildingLog/BuildingLog';

interface LastCheckItemProps {
  registry: {
    type: string;
    iconName: string;
    title: string;
  };
  lastCheckDate: string;
  lastLogs?: BuildingLogItem[];
  isLoading: boolean;
  /** Rejstřík zatím nemá výsledek kontroly, ale je na něj naplánovaná úloha. */
  isPlanned?: boolean;
}

const LastCheckItem: React.FC<LastCheckItemProps> = ({
  registry,
  lastCheckDate,
  lastLogs,
  isLoading,
  isPlanned = false,
}) => {
  const renderStatus = () => {
    if (!lastLogs || lastLogs.length === 0) return null;

    const hasChanges = lastLogs.some((log) => log.isChanged);

    return hasChanges ? (
      <>
        <div className="RegistryLastCheck">
          <Icon name={registry.iconName as IconNames} color="AccentOrange" className="RegistryLastCheck__leftIcon" />
          <Text size="body-medium" className="RegistryLastCheck__title">
            {registry.title}
          </Text>
          <Text size="body-large" weight="600" className="RegistryLastCheck__date">
            {lastCheckDate}
          </Text>
          <Text size="body-small" color="Neutral600" className="RegistryLastCheck__status">
            Nastala změna
          </Text>
        </div>
        <div className="ml-1">
          {lastLogs
            .filter((log) => log.isChanged)
            .map((log) => (
              <BuildingLog key={log.id} log={log} />
            ))}
        </div>
      </>
    ) : (
      <div className="RegistryLastCheck">
        <Icon name={registry.iconName as IconNames} color="AccentOrange" className="RegistryLastCheck__leftIcon" />
        <Text size="body-medium" className="RegistryLastCheck__title">
          {registry.title}
        </Text>
        <Text size="body-large" className="RegistryLastCheck__date">
          {lastCheckDate}
        </Text>
        <Text size="body-small" color="Neutral600" className="RegistryLastCheck__status">
          Beze změny
        </Text>
      </div>
    );
  };

  const renderDefault = () => (
    <div className="RegistryLastCheck">
      <Icon name={registry.iconName as IconNames} color="AccentOrange" className="RegistryLastCheck__leftIcon" />
      <Text size="body-medium" className="RegistryLastCheck__title">
        {registry.title}
      </Text>
      <div className="RegistryLastCheck__date">
        {isLoading ? (
          <Spinner size="small" />
        ) : isPlanned ? (
          <div className="Flex FlexAlign--center" style={{ gap: '0.6rem' }}>
            <Icon name="search" color="Primary500" className="RegistryLastCheck__plannedIcon" />
            <Text size="body-large" weight="600" color="Primary500">
              {t('Registry.lastCheck.planned')}
            </Text>
          </div>
        ) : (
          <Text size="body-large">{lastCheckDate}</Text>
        )}
      </div>
      {!isLoading && isPlanned && (
        <Text size="body-small" color="Neutral600" className="RegistryLastCheck__status">
          {t('Registry.lastCheck.plannedNote')}
        </Text>
      )}
    </div>
  );

  return lastLogs && lastLogs.length > 0 ? renderStatus() : renderDefault();
};

export default LastCheckItem;
